import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableAgentListView extends JetView {
    // Defining a new class extending JetView
    config() {
        // Method to define the configuration of the view
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Custom checkbox template for the Action column
         * @param {Object} obj - The data object for the row
         * @param {Object} common - Common properties for the checkbox
         * @param {string} value - The value to determine the checkbox state
         * @returns {string} - HTML string for the custom checkbox
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'I')
                return ''; // Return empty if value is not 'I'
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>'; // Return HTML for approved and rejected buttons
        }

        return {
            view: 'datatable', // Defining a datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
            columns: [
                // Define columns for the datatable
                {
                    id: 'Action', // Column ID
                    header: '', // Column header
                    template: custom_checkbox, // Custom template for the column
                    width: 100, // Column width
                },
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip text
                    template: function (obj) {
                        // Template function for detail icon
                        return "<span class='webix_icon wxi-close details'></span>"; // Return HTML for detail icon
                    },
                },
                { id: 'Id', header: _('ID Usuario'), width: 100, sort: 'int' }, // Column for User ID
                {
                    id: 'Login', // Column ID
                    header: _('Usuario (Correo electrónico)'), // Column header
                    width: 250, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'IsRegisterActivate', // Column ID
                    header: _('Estado de Registro'), // Column header
                    editor: 'combo', // Editor type
                    options: [
                        // Options for the combo editor
                        { id: 'A', value: _('Activo') }, // Active option
                        { id: 'I', value: _('Inactivo') }, // Inactive option
                        { id: 'R', value: _('Rechazado') }, // Rejected option
                    ],
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'IsActivate', // Column ID
                    header: _('Estado'), // Column header
                    options: [
                        // Options for the column
                        { id: 'A', value: _('Activo') }, // Active option
                        { id: 'I', value: _('Inactivo') }, // Inactive option
                    ],
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'CreatedLocalDate', // Column ID
                    header: _('Fecha de Creación'), // Column header
                    fillspace: 0, // Fill space setting
                    minWidth: 0, // Minimum width
                    width: 150, // Column width
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date format
                },
                {
                    id: 'LastLoginLocalDate', // Column ID
                    header: _('Fecha de ultimo login'), // Column header
                    fillspace: 0, // Fill space setting
                    minWidth: 0, // Minimum width
                    width: 200, // Column width
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date format
                },
            ],
            onClick: {
                // Event handlers for click events
                details: function (euv, id) {
                    // Handler for detail icon click
                    if (vthis.getUrl()[0].page !== 'customers')
                        // Check current page
                        vthis.show('customers?user=' + id + '/information'); // Show customer information
                    else vthis.show('information'); // Show general information
                },
                approbarbutton: function (ev, id) {
                    // Handler for approve button click
                    var item = this.getItem(id); // Get the clicked item
                    if (item.IsRegisterActivate == 'I') {
                        // Check if item is inactive
                        const data = {
                            // Data to send in the request
                            Id: item.Id,
                            Action: 'A', // Action to approve
                        };
                        webix // AJAX request to approve the item
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/SetStateValidate', // API endpoint
                                data, // Data to send
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        // Error handler
                                        webix.message('Error'); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        // Success handler
                                        var json = JSON.parse(text); // Parse response
                                        if (json.HasError) {
                                            // Check for errors in response
                                            webix.message({
                                                title: '¡Error!', // Error title
                                                type: 'alert-error', // Error type
                                                text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                            });
                                        } else {
                                            item.IsRegisterActivate = 'A'; // Update item status
                                            item.Action = 'A'; // Update action
                                            webix.message(_('Guardado')); // Show success message
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            // Show error if item cannot be approved
                            title: '¡Error!',
                            type: 'alert-error',
                            text: _('No puedes activar un registro ya actualizado.'),
                        });
                    }
                },
                rechazarbutton: function (ev, id) {
                    // Handler for reject button click
                    var item = this.getItem(id); // Get the clicked item
                    if (item.IsRegisterActivate == 'I') {
                        // Check if item is inactive
                        const data = {
                            // Data to send in the request
                            Id: item.Id,
                            Action: 'R', // Action to reject
                        };
                        webix // AJAX request to reject the item
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/SetStateValidate', // API endpoint
                                data, // Data to send
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        // Error handler
                                        webix.message('Error'); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        // Success handler
                                        var json = JSON.parse(text); // Parse response
                                        if (json.HasError) {
                                            // Check for errors in response
                                            webix.message({
                                                title: '¡Error!', // Error title
                                                type: 'alert-error', // Error type
                                                text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                            });
                                        } else {
                                            item.IsRegisterActivate = 'I'; // Update item status
                                            item.Action = 'I'; // Update action
                                            webix.message(_('Guardado')); // Show success message
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            // Show error if item cannot be rejected
                            title: '¡Error!',
                            type: 'alert-error',
                            text: _('No puedes activar un registro ya actualizado.'),
                        });
                    }
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/Client/GetClients', // Data source URL
            on: {
                // Event handlers for the datatable
                onItemDblClick: (id) => {
                    // Handler for double-click event
                    if (this.getUrl()[0].page !== 'customers')
                        // Check current page
                        this.show('customers?user=' + id + '/information'); // Show customer information
                    else this.show('information'); // Show general information
                },
            },
        };
    }
    init(grid) {
        // Method to initialize the grid
        var url = grid.data.url; // Get the data URL
        this.on(this.app, 'playersList:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Check for datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format dateFrom for query string
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format dateTo for query string
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        grid.attachEvent('onBeforeEditStart', function (id) {
            // Event handler before editing starts
            var item = this.getItem(id); // Get the item being edited
            console.log(item); // Log the item
            if (id.column == 'Action') {
                // Check if editing the Action column
                var options = this.getColumnConfig('Action').collection; // Get column options
                if (item.IsRegisterActivate != 'I') {
                    // Check if item is inactive
                    console.log(item); // Log the item
                    return false; // Prevent editing
                }
                console.log(id); // Log the ID
            }
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                // Load grid data based on selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
